import React from "react";
import ControlDetailsPanel from "../details/ControlDetailsPanel";
import { useNavigate } from "react-router-dom";
import { ITimer } from "./types";
import { IControl } from "../types";
import TimerList from "./TimerList";
import FloatingActionButton from "../../../Components/FloatingActionButton";
import { t } from "i18next";

interface ITimersProps {
  control: IControl;
  timers: ITimer[];
}

const Timers = (props: ITimersProps) => {
  const { control, timers } = props;
  const navigate = useNavigate();
  const handleAddTimer = () => navigate(`/controls/${control.id}/timers/-1`);
  return (
    <ControlDetailsPanel
      mode={control.is_enabled ? "on" : "disabled"}
      title={t("Timers of CONTROL", { control })}
    >
      <TimerList control={control} timers={timers} />
      <FloatingActionButton
        iconName="timer-plus-outline"
        onClick={handleAddTimer}
      />
    </ControlDetailsPanel>
  );
};

export default Timers;
